import React from 'react';
import FormItem from './general/formitem.js';

export default class PasswordChange extends React.Component
{
    constructor(props)
    {
        super(props);
        this.inputChanged = this.inputChanged.bind(this);
        this.state = {
            loaded: true,
            submissionAttempted: false,
            error: "",
            formData: {
                password: "",
                confirmpassword: ""
            },
            validationErrors: []
        }
    }
    validate()
    {
        if (this.state.submissionAttempted)
        {
            var errors = [];
            if (this.state.formData.password.trim() === "")
            {
                errors.push({message: "Password is required.", element: "password"});
            }
            if (this.state.formData.password.trim() !== this.state.formData.confirmpassword.trim() || this.state.formData.confirmpassword.trim() === "")
            {
                errors.push({message: "Confirm password must match password.", element: "confirmpassword"});
            }
            this.setState({validationErrors: errors});
            if (errors.length > 0)
            {
                return false;
            }
        }
        return true;
    }
    inputChanged(event)
    {
        var data = this.state.formData;
        data[event.target.name] = event.target.value;
        this.setState({formData: data}, () => this.validate());
    }
    submitPasswordChange(e)
    {
        e.preventDefault();
        this.setState({submissionAttempted: true}, () => this.changePassword());
    }
    changePassword()
    {
        if (this.validate())
        {
            this.setState({loaded: false});
            this.props.api.send({
                controller: "Authentication",
                action: "ChangePassword",
                method: "post",
                body: JSON.stringify(this.state.formData),
                success: (result) =>
                {
                    if (result.success)
                    {
                        this.setState({loaded: true});
                        this.props.onChange();
                    }
                    else
                    {
                        this.setState({error: result.message, loaded: true});
                    }
                },
                error: (err) =>
                {
                    this.setState({loaded: true, error: "An error occurred while changing password.  Please try again later."})
                }
            })
        }
    }
    render()
    {
        return (
            <div>
                <h2>Change Password</h2>
                <div className="lmsform">
                    <div className="lmsformheading">
                        Chagne Password
                    </div>
                    <div className="lmsformbody">
                    { this.state.loaded ? (
                        <div>
                            <form className="lmsforminner" method="post" onSubmit={(e) => this.submitPasswordChange(e)}>
                                <FormItem label="New Password:" name="password" type="password"
                                    inputChanged={this.inputChanged} value={this.state.password}
                                    validationErrors={this.validationErrors} />
                                <FormItem label="Confirm New Password:" name="confirmpassword" type="password"
                                    inputChanged={this.inputChanged} value={this.state.confirmpassword}
                                    validationErrors={this.validationErrors} />
                                <div className="lmsvalidationerror lmscenter">
                                    <span>{this.state.validationErrors.map((err) =>
                                        <p key={err.element}>{err.message}</p>
                                    )}</span>
                                </div>
                                <div className="lmsvalidationerror lmscenter">
                                        {this.state.error}
                                </div>
                                <div className="lmsformfooter">
                                    <input type="submit" name="reset" value="Reset" className="lmsbutton" />
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="lmscenter">
                            <img src="/images/spinner.svg" alt="Loading..." />
                        </div>
                    )}
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/passwordchange.js